import Swiper, {Navigation, Mousewheel, Autoplay} from 'swiper';

$(document).ready(function () {

    initShopHeadSlider();

    productsView();

    toggleFilterMenu();

});

const initShopHeadSlider = () => {
    const container = '.shop-head-slider';

    new Swiper(container, {
        modules: [Navigation, Mousewheel, Autoplay],
        spaceBetween: 16,
        slidesPerView: 1.3,
        mousewheel: false,
        autoplay: {
            delay: 2000,
        },
        navigation: {
            prevEl: '.shop-head-slider-prev',
            nextEl: '.shop-head-slider-next',
        },
        breakpoints: {
            1080: {
                slidesPerView: 2.7,
            },

            991: {
                slidesPerView: 1.7,
            },

            768: {
                slidesPerView: 2.7,
            },

            576: {
                slidesPerView: 3.3,
            }
        }
    });
}

const productsView = () => {
    const listViewButton = $('#listView');
    const gridViewButton = $('#gridView');
    const shopContent = $('.shop-content');

    const setProductsView = (view) => {
        const isList = view === 'list';

        shopContent.toggleClass('list-view', isList);
        listViewButton
            .toggleClass('is-active', isList)
            .attr('aria-pressed', isList ? 'true' : 'false');
        gridViewButton
            .toggleClass('is-active', !isList)
            .attr('aria-pressed', !isList ? 'true' : 'false');
    };

    setProductsView('grid');

    listViewButton.on('click', function () {
        setProductsView('list');
    });

    gridViewButton.on('click', function () {
        setProductsView('grid');
    });
}

const toggleFilterMenu = () => {
    const button = $('.filter-menu-btn');
    const close = $('.close-shop-filter');
    const menu = $('.shop-filters');

    button.on('click', function () {
        $('body').addClass('overflow-hidden');
        menu.addClass('show');
    });

    $(close).on('click', function () {
        $('body').removeClass('overflow-hidden');
        menu.removeClass('show');
    });
}
